import { useContext, useEffect } from 'react'
import { LoadingWrapperContext } from 'src/modules/core/context'
import { ConfigurationStepProvider, PaginationProvider } from 'src/modules/core/providers'
import { EventsProvider } from 'src/modules/event/providers'
import { ConfigurationWrapper } from 'src/modules/user/containers'

export function Configuration() {
  const { disableLoading } = useContext(LoadingWrapperContext)

  useEffect(() => {
    disableLoading()
  }, [disableLoading])

  return (
    <ConfigurationStepProvider>
      <PaginationProvider>
        <EventsProvider>
          <ConfigurationWrapper />
        </EventsProvider>
      </PaginationProvider>
    </ConfigurationStepProvider>
  )
}
